import { BehaviorSubject } from 'rxjs';
import { FboFinderFilter } from '../models/fbo-finder-filter.model';
import * as i0 from "@angular/core";
/**
 * Shares the Business Finder (FBO) filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FlightSchoolFinderFiltersService} (a root-provided BehaviorSubject).
 */
var FboFinderFiltersService = /** @class */ (function () {
    function FboFinderFiltersService() {
        this.fboFinderFilterSubject$ = new BehaviorSubject(new FboFinderFilter());
        this.fboFinderFilter = this.fboFinderFilterSubject$.asObservable();
    }
    FboFinderFiltersService.prototype.updateFboFinderFilters = function (fboFinderFilter) {
        this.fboFinderFilterSubject$.next(fboFinderFilter);
    };
    FboFinderFiltersService.ngInjectableDef = i0.defineInjectable({ factory: function FboFinderFiltersService_Factory() { return new FboFinderFiltersService(); }, token: FboFinderFiltersService, providedIn: "root" });
    return FboFinderFiltersService;
}());
export { FboFinderFiltersService };
